import React from 'react';
import { Theme, ThemeContext } from './theme';

const gfiTheme: Theme = {
  backgroundDefault: '#FAFAFA',
  backgroundSecondary: '#f0f2f3',
  primaryExtraDark: '#0E2F6C',
  actionActive: '#595b65cc',
  textDisabled: '#1f1f1f66',
  primaryMain: '#3056D9',
  primaryContrast: '#FFFFFF',
  onlineStatusColor: '#28B865',
  offlineStatusColor: '#F44336',
  textPrimary: '#1F1F1FDE',
  baseTableHeaderBg: '#4CB4FA14',

  primaryFontSize: '0.8rem',
  largeFontSize: '1rem',
  smallFontSize: '0.6rem',
};

export const GfiTheme: React.FC = ({ children }) => {
  React.useEffect(() => {
    // Load roboto font
    const link = document.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('type', 'text/css');
    link.setAttribute(
      'href',
      'https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap'
    );
    document.head.appendChild(link);
  }, []);

  return (
    <ThemeContext.Provider value={gfiTheme}>{children}</ThemeContext.Provider>
  );
};
